import type { AppDefinition } from '../../../../types/apps';

const interactionDefinition: AppDefinition = {
  appId: 'phys-interactions',
  name: 'Interaction Checker',
  version: '1.0.0',
  description:
    'Medication interaction & duplicate-therapy checker — RxNorm normalization, drug class analysis, and FDA label interaction text.',

  entityTypes: [],
  requiresEntity: false,
  requiresProps: false,
  preserveAppInstance: true,

  component: 'phys-interactions',

  icon: {
    type: 'phosphor' as const,
    phosphorIcon: 'Pill',
    phosphorWeight: 'duotone' as const,
    metadata: {
      source: 'app' as const,
      appId: 'phys-interactions',
      isAppIcon: true,
    },
  },

  agenticToolIds: ['physician_widget'],
  features: [],
  category: 'physician',
  isCore: false,
  isSystem: true,
  hidden: true,
};

export default interactionDefinition;
